export default __webpack_public_path__ + "static/media/gothenburg_background_l2.a7f0410e.jpg";